import { Translation } from '@ps/web-shared-components';
import type { ReactNode } from 'react';
import React from 'react';

import { CardType } from '../../types/cardType';

import { TXTWCL_The_XemXInteracX_emX_logo_is_a_ELL } from './SummaryMessages.messages.json';
import { info } from './SummaryMessages.scss';

interface Props {
  type: CardType;
}

const SummaryMessages: React.FC<Props> = ({ type }) => {
  if (type === CardType.Interac) {
    return (
      <div className={info} data-testid="summary-messages-info">
        <Translation
          {...TXTWCL_The_XemXInteracX_emX_logo_is_a_ELL}
          values={{
            em: (msg: ReactNode) => <em>{msg}</em>
          }}
        />
      </div>
    );
  }
  return null;
};

export default SummaryMessages;
